import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import * as React from 'react';
import { Link, LinkProps } from 'react-router-dom';

interface IMenuLinkProps {
  label: string;
  icon: JSX.Element;
  to: string;
  menuClassName?: string;
  onNavClick: () => any;
  isActive?: boolean;
}

let MenuLink: React.FunctionComponent<IMenuLinkProps> = ({
  label,
  icon,
  to,
  menuClassName = '',
  onNavClick,
  isActive
}) => {
  const link = React.forwardRef<HTMLAnchorElement, Omit<LinkProps, 'innerRef' | 'to'>>((props, ref) => (
    <Link to={to} {...props} ref={ref} />
  ));

  return (
    <MenuItem selected={isActive} className={menuClassName} onClick={onNavClick} component={link}>
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemText primary={label} />
    </MenuItem>
  );
};

MenuLink = React.memo<IMenuLinkProps>(MenuLink);
export { MenuLink };
